import { Stack, Typography } from '@mui/material';

import { SProgressbar } from './styled';
import { type ProgressbarProps } from './types';

export const Progressbar = ({ withLabel, ...props }: ProgressbarProps) => (
  <Stack alignItems="center" direction="row" gap={12} width="100%">
    {withLabel ? (
      <Typography color="secondary" variant="body-2-md" width={37}>
        {props.value}%
      </Typography>
    ) : null}

    <SProgressbar variant="determinate" {...props} />
  </Stack>
);
